import type { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import axios from 'axios';
import { API_URLS_LIST } from '@config/api-config';
import { useGlobalStore } from '@services/store/global-store';
import { hideSpinner, showSpinner } from './spinner-service';

const axiosInstance: AxiosInstance = axios.create({
  baseURL: API_URLS_LIST.BASE_URL,
  timeout: 80000,
  headers: {
    'Content-Type': 'application/json'
  }
});
// Request interceptor
axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    showSpinner();
    if(useGlobalStore.getState().virtualMode && config.url) {
      config.url = 'virtual/' + config.url;
    }
    if (config.url?.includes('secure')) {
      const userDetails = useGlobalStore.getState().userDetails;
      
      config.headers['authorization'] = userDetails.jwtToken;
      config.headers['userid'] = userDetails.userId;
      
      // Add OIDC headers following shopper-sos-ui-portal pattern
      const smUserValue = userDetails.userId ? '~' + userDetails.userId : '';
      config.headers['SMUSER'] = smUserValue;
      
      // Set OIDC claim groups - simplified to match shopper-sos-ui-portal
      // In shopper-sos-ui-portal, this is hardcoded for planmatch scenario
      if (userDetails.userInformation?.userRole) {
        config.headers['oidc_claim_groups'] = userDetails.userInformation.userRole;
      }

      if (config.method === 'post' && config.data) {
        if (config.data instanceof FormData) {
          config.headers['Content-Type'] = 'multipart/form-data';
        } else {
          config.data = {
            ...config.data,
            userId: config.data.userId
              ? config.data.userId
              : userDetails.userId,
            firstName: config.data.firstName
              ? config.data.firstName
              : userDetails.userInformation?.firstName,
            lastName: config.data.lastName
              ? config.data.lastName
              : userDetails.userInformation?.lastName
          };
        }
      }
    }
    if(useGlobalStore.getState().virtualMode && 
    useGlobalStore.getState().virtualState && config.method === 'post' && config.data) {    
      config.data.state = useGlobalStore.getState().virtualState;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    hideSpinner();
    return response.data;
  },
  (error) => {
    hideSpinner();
    return Promise.reject(error);
  }
);

export default axiosInstance;